import styled from 'styled-components';

import Button from '~/src/common/components/Button';
import { ButtonsContainer } from '~/src/common/components/NumberPicker/layout';
import { media } from '~/src/styles-constants';

export const Container = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_1};
  overflow: hidden;

  margin: 0 16px;

  ${media.M`
    margin: 0;
    margin-left: 16px;
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;

  background-color: ${({ theme }) => theme.palette.common.BACKGROUND_1};

  font-size: 16px;
  line-height: 16px;
  font-weight: 500;

  & ${ButtonsContainer} {
    margin-left: 16px;
  }
`;

export const ItemsContainer = styled.div`
  padding: 16px;

  display: grid;
  gap: 16px;
  grid-template-columns: 100%;

  ${media.M`
    /* 8px = gap / 2 */
    grid-template-columns: calc(50% - 8px) calc(50% - 8px);
  `}
`;

export const AddToCartButton = styled(Button)`
  margin: 0 auto 16px;
`;

export const IngredientPanelItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
